export const messages = {
  title: '日记',
  add: '写日记',
  empty: '还没有日记，写下第一篇吧',
  mood: '心情',
  save: '保存',
  cancel: '取消',
  placeholder: '今天想说什么…'
} as const
